import * as DashboardConstants from '.././DashboardConstants';

export const RepeatedTerminationBotsHeaders = [
    {
        key: 'automataName',
        header: DashboardConstants.AutomataName
    },
    {
        key: 'leadPlatform',
        header: DashboardConstants.LeadPlatform
    },
    {
        key: 'subArea',
        header: DashboardConstants.SubArea
    },
    {
        key: 'geoName',
        header: DashboardConstants.GeoName
    },
    {
        key: 'criticality',
        header: DashboardConstants.Criticality
    },
    {
        key: 'requestedBy',
        header: DashboardConstants.RequestedBy
    },
    {
        key: 'deliveryModel',
        header: DashboardConstants.DeliveryModel
    },
    {
        key: 'repeatedTerminations',
        header: DashboardConstants.RepeatedTerminations
    },
    {
        key: 'scheduleFrequency',
        header: DashboardConstants.ScheduleFrequency
    },
    {
        key: 'lastExecution',
        header: DashboardConstants.LastExecutionTime
    }
];